import axios from "axios";
import cardChat from "@/components/consultas/cardChat/cardChat.vue";
import ConsultaError from "@/components/consultas/consultaError/consultaError.vue";
import $ from "jquery";

export default {
  name: "VerConsultas",
  props: ["form", "propRegistros", "propsToken"],
  components: {
    cardChat,
    ConsultaError,
  },
  data() {
    return {
      loadingCards: true,
      idConsulta: "",
      userId: "",
      panel: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      duvidaResolvida: false,
      inputDuvida: false,
      novaDuvida: {
        txMensagem: "",
        loader: false,
        postStatus: "",
        blReplique: "",
        idTipoRetorno: "",
        intQtdAnexos: 0,
        file: [],
      },
      fileRules: [
        (files) => {
          var totalSize = 0;
          if (files) {
            files.forEach((file) => {
              totalSize = totalSize + file.size;
            });
          }

          return (
            !files ||
            totalSize < 25000000 ||
            "Os arquivos necessitam ter menos de 25mb"
          );
        },
      ],
      fileError: {
        status: false,
        messages: [],
      },
      fileTemp: [],
      dadosSolicitante: {
        cidade: "",
        email: "",
        fone: "",
        nome: "",
        uf: "",
      },
      valid: true,
      submitted: false,
      likeDislike: "",
      consulta: {
        result: false,
        consulta: {
          dataCadastro: "",
          ultimaResposta: "",
          nomeConsultor: "",
          nomeArea: "",
          nomeCliente: "",
          emailConsulta: "",
          emailConsulta2: "",
          telefone: "",
          cidadeCliente: "",
          strNomeArea: "",
          strUF: "",
          nomeTema: "",
          intIndice: "",
          idArea: "",
        },
        mensagens: [
          {
            id: "",
            mensagem: "",
            assunto: "",
            dataCadastro: "",
            nomeConsultor: "",
            nomeTema: "",
            areaMensagem: "",
            tipo: "",
            dataAvaliacao: "",
            nota: "",
            anexos: "",
          },
        ],
      },
      attrLoader: {
        class: "ma-6",
        boilerplate: false,
      },
      motivos: [
        {
          id: 1,
          strNome: "Novo assunto",
        },
        {
          id: 2,
          strNome: "Resposta incompleta",
        },
        {
          id: 3,
          strNome: "Resposta inadequada",
        },
        {
          id: 4,
          strNome: "Replique",
        },
        {
          id: 5,
          strNome: "Complementação de Pergunta",
        },
        {
          id: 6,
          strNome: "Resposta recebida não atende a pergunta enviada",
        },
        {
          id: 7,
          strNome: "Elogio",
        },
      ],
      justificativa: [
        {
          id: 1,
          strDescricao: "N\u00e3o respondeu a d\u00favida",
          blAtivo: 1,
        },
        {
          id: 2,
          strDescricao: "N\u00e3o atende o questionamento",
          blAtivo: 1,
        },
        {
          id: 3,
          strDescricao: "Base Legal",
          blAtivo: 1,
        },
      ],
    };
  },
  mounted() {
    this.obterConsulta();
  },
  created() {
    //this.dadosConsulta;
  },
  watch: {
    $route(to, from) {
      this.loadingCards = true;
      this.consulta.result = false;
      this.obterConsulta();
    },
  },
  computed: {
    calcFileTotal() {
      var total = 0;
      this.novaDuvida.file.forEach((file) => {
        total = total + file.size;
      });

      return total;
    },

    consultaExpirada() {
      const dataConsulta = new Date(this.consulta.consulta.ultimaResposta);
      const hoje = new Date();
      const diferencaTempo = Math.abs(hoje - dataConsulta);
      const differencaDias = Math.ceil(diferencaTempo / (1000 * 60 * 60 * 24));
      //console.log(diffTime + " milliseconds");
      //console.log(differencaDias+'dias')

      return differencaDias >= 30;
    },
    anoCadastro() {
      return this.$route.query.ano;
    },
  },
  methods: {
    openPrinter() {
      window.print();
    },

    obterConsulta() {
      this.idConsulta = this.$route.params.id;
      var cookieId = this.$root.$api.getCookie("bG9naW4");
      cookieId = JSON.parse(atob(decodeURIComponent(cookieId)));
      this.$root.$store.state.idUsuario = cookieId.id;

      /**
       * Setando esse id estáticamente para testes
       */
      //	this.$root.$store.state.idUsuario = '17911'

      var token = this.$root.$api.getCookie("operacional");
      var userId = this.$root.$store.state.idUsuario;

      var data = new FormData();
      data.append("idCliente", userId);
      data.append("idConsultoria", this.idConsulta);
      data.append("ano", this.anoCadastro);
      data.append("token", token);

      var config = {
        method: "POST",
        url:
          process.env.VUE_APP_ROOT_API +
          "Services/Consultoria/ConsultoriaIntegracao/ListarConsulta",
        data: data,
      };

      var that = this;
      axios(config)
        .then(function (response) {
          if (response.status === 200 && response.data.result == true) {
            that.consulta = response.data;
            that.loadingCards = false;
            that.$root.$store.state.currentConsulta = {
              intIndice: response.data.consulta.intIndice,
            };
            setTimeout(function () {
              $(".card-consulta-mensagem").find("a").attr("target", "_blank");
            }, 500);
          } else {
            that.loadingCards = false;
          }
        })
        .catch(function (error) {});
    },

    /* 		updateFile(file) {
					file.forEach(itemFile => {
						this.novaDuvida.file.push(itemFile)
					});


					this.novaDuvida.intQtdAnexos = file !== null || file !== undefined ? this.novaDuvida.file.length : 0
				}, */

    updateFile(file) {
      var totalSize = this.calcFileTotal;

      if (file) {
        file.forEach((itemFile) => {
          /**
           * Checa se já existe um arquivo com mesmo nome
           *
           */

          totalSize = totalSize + itemFile.size;
          /* 	console.log(totalSize)
						console.log(itemFile)
						console.log(totalSize/1000000) */

          if (this.novaDuvida.file.length >= 3) {
            this.fileError.status = 3;
            return;
          }
          if (totalSize >= 25000000) {
            this.fileError.status = 1;
            return;
          }
          if (
            this.novaDuvida.file.some((item) => item.name === itemFile.name)
          ) {
            this.fileError.status = 2;
            this.fileError.messages.push(itemFile.name);
            return;
          }
          if (itemFile.size >= 25000000) {
            return;
          } else {
            this.fileError.status = 0;
            this.fileError.messages = [];
            this.novaDuvida.file.push(itemFile);
          }
        });
      }
      this.fileTemp = [];
      this.novaDuvida.intQtdAnexos =
        (file !== null) & (file !== undefined)
          ? this.novaDuvida.file.length
          : 0;
    },

    cleanFile(index) {
      this.novaDuvida.file.splice(index, 1);
      this.$refs.file_upload2.reset();
    },

    postLikeDislike(status) {
      //faz um post com o like ou dislike
      this.likeDislike = status;
    },

    getClass(p_prioridade) {
      switch (p_prioridade) {
        case "baixa":
          return "i-green";
        case "media":
          return "i-yelow";
        case "alta":
          return "i-red";
        default:
          return "i-green";
      }
    },
    iniciarDuvida() {
      this.inputDuvida = true;
    },
    enviarDuvida() {
      this.$refs.form.validate();
      var duvidaPost = {
        tipo: "cliente",
        id: "",
        nome: this.dadosSolicitante.nome,
        created_at: "",
        corpo_mensagem: this.novaDuvida.corpo_mensagem,
      };

      console.log(this.$root.$store.state);
      if (this.$refs.form.validate() === true) {
        this.showResult = true;
        this.novaDuvida.loader = true;

        /* idJustificacaoReplique: '1', */
        var checkReplique = this.novaDuvida.idTipoRetorno === 4 ? 1 : 0;

        var objForm = {
          txMensagem: this.novaDuvida.txMensagem,
          idConsultoria: this.idConsulta,
          blReplique: checkReplique,
          idTipoRetorno: this.novaDuvida.idTipoRetorno,
          intQtdAnexos: this.novaDuvida.intQtdAnexos,
          idUsuario: this.$root.$store.state.idUsuario,
          token: this.$root.$store.state.token,
        };

        var form = new FormData();
        form.append("idJustificacaoReplique", objForm.idJustificacaoReplique);
        form.append("txMensagem", objForm.txMensagem);
        form.append("idConsultoria", objForm.idConsultoria);
        form.append("blReplique", objForm.blReplique);
        form.append("idTipoRetorno", objForm.idTipoRetorno);
        form.append("intQtdAnexos", objForm.intQtdAnexos);
        form.append("idUsuario", objForm.idUsuario);
        form.append("acao", "novaPergunta");
        form.append("botao", "Enviar");
        form.append("token", objForm.token);

        /**
         * Em caso da existência de arquivos
         * Faremos um forEach para gerar a chave o valor do formulário de acordo com o padrão da API
         * File1, ''
         * File2, ''
         *
         */
        if (this.novaDuvida.file) {
          this.novaDuvida.file.forEach((file, index) => {
            var name = "file" + (index + 1);

            form.append(name, file);
          });
        }

        this.$root.$api
          .novaPergunta(objForm.token, form)
          .then((response) => {
            if (response && response.data.resultado == "ok") {
              this.novaDuvida.postStatus = "success";

              this.novaDuvida.loader = false;
              this.obterConsulta();
              this.inputDuvida = false;
              setTimeout(() => {
                setTimeout(() => {
                  this.loaderOk = false;
                }, 1000);
              }, 100);
            } else {
              console.log(response.data);
              this.novaDuvida.postStatus = "error";
            }
          })
          .catch((error) => {
            //console.log('Erro: ', error)
            console.log(error);
            this.novaDuvida.postStatus === "error";
          });
      }
    },
  },
};
